module.exports = __webpack_public_path__ + "static/img/public_banner.5a7687f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/public_banner.png
// module id = ocuU
// module chunks = 34